// extracted by mini-css-extract-plugin
module.exports = {"products":"userFavorites_products__JLuE3"};